import { useState, useEffect, useCallback } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getUnreadCount } from '../../APIs/notificationsApi';

export default function NotificationBell({ iconSize = 'w-6 h-6', className = '' }) {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const fetchCount = useCallback(async () => {
    try {
      const res = await getUnreadCount();
      setCount(res.data?.unread_count ?? 0);
    } catch {
      // silent
    }
  }, []);

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, 60_000);
    return () => clearInterval(interval);
  }, [fetchCount]);

  const badge = count > 0 ? (count > 9 ? '9+' : String(count)) : null;

  return (
    <button
      onClick={() => navigate('/notifications')}
      className={`relative p-2 rounded-full hover:bg-white/10 transition ${className}`}
    >
      <Bell className={`${iconSize} text-white/70 hover:text-white transition`} />
      {badge && (
        <span className="absolute top-0.5 right-0.5 min-w-[18px] h-[18px] px-1
          bg-red-500 rounded-full flex items-center justify-center
          text-[10px] font-bold text-white leading-none">
          {badge}
        </span>
      )}
    </button>
  );
}
